// extracted by mini-css-extract-plugin
export default {"iconPreview":"IconPreview_iconPreview__Xe6ZA","iconPreview__iconText":"IconPreview_iconPreview__iconText__QuOz1","error":"IconPreview_error__6buea"};